import { useState } from 'react';
import { api, errorText } from '../../api';
import { ConfirmDialog } from '../../components/Dialog';
import { t } from '../../i18n';
import { useToast } from '../../lib/toast';
import type { EmployeeDetail } from './types';

// „Per E-Mail schicken“ (Sam 12.10.): Die App schickt an die Adresse aus dem Personalfragebogen einen Link, mit dem der
// Mitarbeiter die Datei mit seinem Geburtsdatum öffnet; Antworten gehen an den Arbeitgeber
// (server/src/modules/lohn/mitarbeiter-mail.ts). Ohne Adresse steht dort „Keine E-Mail vorhanden“ (Sam 12.10.).
export function MailToEmployee({ e, url, text }: { e: EmployeeDetail; url: string; text: string }) {
  const toast = useToast();
  const [ask, setAsk] = useState(false);
  const [busy, setBusy] = useState(false);
  if (!e.email) {
    return (
      <button type="button" className="btn2" disabled>
        {t('Keine E-Mail vorhanden')}
      </button>
    );
  }
  async function send() {
    setBusy(true);
    try {
      const r = await api.post<{ sentTo: string }>(url);
      toast(t('Link per E-Mail an {email} geschickt', { email: r.sentTo }));
    } catch (err) {
      toast(errorText(err));
    } finally {
      setBusy(false);
      setAsk(false);
    }
  }
  return (
    <>
      <button type="button" className="btn2" onClick={() => setAsk(true)}>
        {t('Per E-Mail schicken')}
      </button>
      <ConfirmDialog
        open={ask}
        title={t('Per E-Mail an {name}?', { name: e.name })}
        text={`${text} ${t('Antworten gehen an Ihre E-Mail-Adresse.')}`}
        confirmLabel={t('Ja, schicken')}
        busy={busy}
        onConfirm={send}
        onCancel={() => setAsk(false)}
      />
    </>
  );
}
